import React, { Component } from "react";
import {
  company,
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  GET,
  POST,
  PUT,
  DELETE,
  alert,
  Select,
  activeOptions,
  activeTreeOptions,
  t,
  sortOptions,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ
import { required } from "../../utils/helpers.js";
import { can } from "../../utils/permission";

export default class PartsMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_category: "",
      filter_status: "",
      
      count: 0,
      page: 1,
      page_size: 10,
      data: [],
      data_parts: [],
      data_brands: [],
      data_series: [],
      data_models: [],
      data_categories: [],
      data_uoms: [],
      data_suppliers: [],

      // Modal States
      modal_create: false,
      modal_view: false,
      selected_part: null,
      uid: "",

      // Form States (for Modal)
      form_part_code: "",
      form_category1: "",
      form_category2: "",
      form_category3: "",
      form_desc: "",
      form_brand: "",
      form_model: "",
      form_serie: "",
      form_unit: "",
      form_unit_cost: "0",
      form_unit_price: "0",
      form_reorder_pt: "0",
      form_min_stock: "0",
      form_max_stock: "0",
      form_reorder_qty: "0",
      form_lead_time: "0",
      form_supplier: "",
      form_barcode: "",
      form_legacy_part_id: "",
      form_compatible_series: [],
      form_is_active: true,

      select_compatible_series: "",

      // Mock Data: Summary Stats
      summary: {
        total_items: 0,
        active: 0,
        inactive: 0,
        categories: 0,
      },

      categoryOptions: [
        { id: '2feb6751-2626-4997-a7b1-4e27d6469409', label: 'เครื่องพิมพ์', icon: '🖨️' }, // สมมติ ID
        { id: 'cat-02', label: 'เครื่องตัด', icon: '✂️' },
        { id: 'cat-03', label: 'UV Printer', icon: '💡' },
        { id: 'cat-04', label: 'Plotter', icon: '📐' },
        { id: 'cat-05', label: 'อุปกรณ์อื่นๆ', icon: '🔩' }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
    this.GetSummary();
    this.GetReferenceData();
    this.Get(1);
  }

  // KPI: นับด้วย aggregate ฝั่ง backend (summary=true) ไม่ดึงข้อมูลทั้งตารางมานับเอง
  GetSummary = async () => {
    let result = await GET("warehouse/part-masters", { summary: "true" });
    if (result?.status && result.data) {
      this.setState({
          summary: {
              total_items: result.data.total_items || 0,
              active: result.data.active || 0,
              inactive: result.data.inactive || 0,
              categories: result.data.categories || 0,
          },
      });
    }
  };

  // ข้อมูลอ้างอิงสำหรับ dropdown: โหลดครั้งเดียวตอนเข้าหน้า (และหลัง save) ไม่โหลดซ้ำทุกครั้งที่เปลี่ยนหน้า
  GetReferenceData = async () => {
    let [result_brands, result_models, result_categories, result_uoms, result_suppliers, result_parts, result_series] = await
      Promise.all([
        GET("warehouse/brands",{page_size: 10000,  page: 0}),
        GET("warehouse/models",{page_size: 10000,  page: 0}),
        GET("warehouse/part-categories",{page_size: 10000,  page: 0}),
        GET("warehouse/uoms",{page_size: 10000,  page: 0}),
        GET("warehouse/suppliers",{page_size: 10000,  page: 0}),
        // lite=true: backend ส่งเฉพาะ uid/part_number/name ไม่ join relation
        GET("warehouse/part-masters",{page_size: 10000,  page: 0, lite: "true"}),
        GET("warehouse/series",{page_size: 10000,  page: 0})
      ]);

    this.setState({
      data_brands: result_brands?.status ? (result_brands?.data || []) : [],
      data_models: result_models?.status ? (result_models?.data?.map(e=>({is_active: e.is_active, value: e.uid, label: e.name})) || []) : [],
      data_categories: result_categories?.status ? (result_categories?.data?.map(e=>({is_active: e.is_active, value: e.uid, label: e.name})) || []) : [],
      data_uoms: result_uoms?.status ? (result_uoms?.data?.map(e=>({is_active: e.is_active, value: e.uid, label: e.name})) || []) : [],
      data_suppliers: result_suppliers?.status ? (result_suppliers?.data?.map(e=>({is_active: e.is_active, value: e.uid, label: e.name})) || []) : [],
      data_parts: result_parts?.status ? (result_parts?.data?.map(e=>({is_active: e.is_active, value: e.uid, label: e.name})) || []) : [],
      data_series: result_series?.status ? (result_series?.data?.map(e=>({is_active: e.is_active, value: e.uid, label: e.name})) || []) : [],
    });
  };

  Get = async (page) => {
    const { filter_search, page_size, filter_status, filter_category } = this.state;
    loading(true);

    let result = await GET("warehouse/part-masters", {
      page_size: page_size,
      page: page,
      category_id: filter_category || "",
      data_search: filter_search || "",
      is_active: filter_status || "",
    });

    if (result?.status) {
      this.setState({
        data: result?.data || [],
        count: result?.pagination?.count || 0,
        page: page,
      });
    }
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid, form_part_code, form_desc, form_brand, form_model, form_category1, form_category2, form_category3,
      form_serie,
      form_unit, form_unit_cost, form_unit_price, form_min_stock, form_max_stock,
      form_reorder_pt, form_reorder_qty, form_lead_time, form_supplier, form_barcode, form_is_active,
      form_legacy_part_id,
      form_compatible_series
    } = this.state;

    // Validation เบื้องต้น
    if (!form_part_code.trim()) {
      alert("", "warning", t("warning"), t("please_enter_part_code"));
      return;
    }
    if (!form_desc.trim()) {
      alert("", "warning", t("warning"), t("please_enter_description"));
      return;
    }
    if (!form_category1.trim()) {
      alert("", "warning", t("warning"), t("please_select_category_1"));
      return;
    }
    if (!form_unit.trim()) {
      alert("", "warning", t("warning"), t("please_select_unit"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel")
      )
    ) {
      loading(true);
      
      let company_id = company?.id || "446a2297-d012-43a1-af6c-eda4055099cf";

      // Payload อ้างอิงตาม cURL
      let body = {
        company_id: company_id,
        part_number: form_part_code,
        name: form_desc,
        description: form_desc,
        brand_id: form_brand,
        model_id: form_model,
        part_category_id: form_category1,
        part_category_id_2: form_category2,
        part_category_id_3: form_category3,
        serie_id: form_serie,
        uom_id: form_unit,
        uom_cost: Number(form_unit_cost) || 0,
        selling_price: Number(form_unit_price) || 0,
        min_stock: Number(form_min_stock) || 0,          
        max_stock: Number(form_max_stock) || 0,         
        reorder_point: Number(form_reorder_pt) || 0,      
        reorder_qty: Number(form_reorder_qty) || 0,        
        lead_time_days: Number(form_lead_time) || 0,    
        supplier_id: form_supplier,
        barcode: form_barcode,
        legacy_part_id: form_legacy_part_id,
        compatible_series: form_compatible_series,
        picture: "",
        is_active: form_is_active
      };

      let result = !uid
        ? await POST("warehouse/part-masters", body)
        : await PUT("warehouse/part-masters/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false });
        this.resetForm();
        this.Get(this.state.page);
        this.GetSummary();
        this.GetReferenceData();
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel")
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/part-masters/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1);
        this.GetSummary();
        this.GetReferenceData();
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  Edit = (item) => {
    // console.log("item.compatible_series?.map(e => e.uid):",item.compatible_series?.map(e => e.uid))
    this.setState({
      modal_create: true,
      uid: item.uid,
      form_part_code: item.part_number || "",
      form_desc: item.name || item.description || "",
      form_brand: item.brand?.uid || "",
      form_model: item.model?.uid || "",
      form_category1: item.part_category?.uid || "",
      form_category2: item.part_category_2?.uid || "",
      form_category3: item.part_category_3?.uid || "",
      form_unit: item.uom?.uid || "",
      form_serie: item.serie?.uid || "",
      form_unit_cost: item.uom_cost?.toString() || "0",
      form_unit_price: item.selling_price?.toString() || "0",
      form_min_stock: item.min_stock?.toString() || "0",
      form_max_stock: item.max_stock?.toString() || "0",
      form_reorder_pt: item.reorder_point?.toString() || "0",
      form_reorder_qty: item.reorder_qty?.toString() || "0",
      form_lead_time: item.lead_time_days?.toString() || "0",
      form_supplier: item.supplier?.uid || "",
      form_barcode: item.barcode || "",
      form_legacy_part_id: item.legacy_part?.uid || "",
      form_compatible_series: item.compatible_series?.map(e => e.uid) || [],
      form_is_active: item.is_active !== undefined ? item.is_active : true,
    });
  };

  View = (item) => {
    this.setState({
      modal_view: true,
      selected_part: item
    });
  };

  resetForm = () => {
    this.setState({
      uid: "",
      form_part_code: "",
      form_desc: "",
      form_brand: "",
      form_model: "",
      form_category1: "",
      form_category2: "",
      form_category3: "",
      form_unit: "",
      form_serie: "",
      form_unit_cost: "0",
      form_unit_price: "0",
      form_min_stock: "0",
      form_max_stock: "0",
      form_reorder_pt: "0",
      form_reorder_qty: "0",
      form_lead_time: "0",
      form_supplier: "",
      form_barcode: "",
      form_legacy_part_id: "",
      form_compatible_series: [],
      form_is_active: true,
    });
  };

  formatNumber = (num) => {
    return num?.toLocaleString() || "0";
  };

  render() {
    const { 
      data, count, data_brands, data_models, data_categories, data_uoms, data_suppliers,data_parts,data_series,
     summary, categoryOptions,
      filter_search, filter_category, filter_status,
      modal_create, modal_view, selected_part,
      form_part_code, form_brand, form_model, form_category1, form_category2, form_category3,
      form_serie, form_desc, 
      form_unit, form_unit_cost, form_unit_price, form_reorder_pt, 
      form_min_stock, form_reorder_qty, form_lead_time, form_supplier, form_barcode,
      form_legacy_part_id,
      form_compatible_series,
      select_compatible_series
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="mb-4">
                    <h3 className="fw-bold mb-1 text-dark">{t("parts_info")}</h3>
                    <div className="text-secondary text-14">{t("manage_parts_config")}</div>
                </div>

                {/* Top Stats Cards (4 Columns) */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf013"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.total_items)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("total_parts")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.active)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("active")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-light text-secondary border d-flex align-items-center justify-content-center text-20 icon">{"\uf2ed"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.inactive)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("inactive")}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                            <div className="d-flex align-items-center">
                                <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf5fd"}</div>
                                <div>
                                    <h3 className="fw-bold text-dark mb-0">{this.formatNumber(summary.categories)}</h3>
                                    <div className="text-secondary text-12 fw-bold">{t("category")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="border-bottom border-light d-flex flex-wrap justify-content-between align-items-center gap-3">
                        <div className="d-flex gap-3 flex-wrap flex-grow-1">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_placeholder")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <Select
                                className="form-control wpx-180"
                                options={data_categories}
                                value={filter_category}
                                onChange={(e) => {
                                    this.setState({ filter_category: e });
                                }}
                                placeholder={t("select_type")}
                            />
                            <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                                <option value="">{t("all_statuses")}</option>
                                <option value="true">{t("active")}</option>
                                <option value="false">{t("inactive")}</option>
                            </select>
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() =>
                                        this.setState(
                                            {
                                                filter_search: "",
                                                filter_status: "",
                                                filter_category: "",
                                            },
                                            () => this.Get(1)
                                        )
                                    }
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            {/* <button className="btn btn-white bg-white border border-light px-3 py-2 fw-bold rounded-3 shadow-sm text-dark d-flex align-items-center">
                                <span className="icon me-2 text-14">{"\uf093"}</span> {t("import")}
                            </button>
                            <button className="btn btn-white bg-white border border-light px-3 py-2 fw-bold rounded-3 shadow-sm text-dark d-flex align-items-center">
                                <span className="icon me-2 text-14">{"\uf019"}</span> {t("export")}
                            </button> */}
                            {can("part-master.create") && (
                            <button
                                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                                style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                                onClick={() => {
                                    this.resetForm();
                                    this.setState({ modal_create: true });
                                }}
                            >
                                <span className="me-2 text-16">+</span> {t("add_part")}
                            </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm pb-2">
                    {/* Parts Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1800px" }}>
                            <thead>
                                <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0">{t("part_code")}</th>
                                    <th className="py-3 border-0">{t("description")}</th>
                                    <th className="py-3 border-0">{t("brand_header")}</th>
                                    <th className="py-3 border-0">{t("model_1")}</th>
                                    <th className="py-3 border-0">{t("model_2")}</th>
                                    <th className="py-3 border-0 text-center">{t("category_1")}</th>
                                    <th className="py-3 border-0 text-center">{t("unit")}</th>
                                    <th className="py-3 border-0 text-center">{t("reorder_point")}</th>
                                    <th className="py-3 border-0 text-center">{t("min_order")}</th>
                                    <th className="py-3 border-0 text-center">{t("lead_time")}</th>
                                    <th className="py-3 border-0 text-end">{t("unit_cost")}</th>
                                    <th className="py-3 border-0 text-center">{t("status")}</th>
                                    <th className="py-3 border-0 text-center">{t("manage")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.length > 0 ? (
                                    data?.map((item, idx) => {
                                        const isActive = item.is_active !== false; // สมมติว่า true คือ Active
                                        const statusText = isActive ? t("active") : t("inactive");
                                        const statusColor = isActive ? "success" : "secondary";

                                        // ดึงค่าจาก Object ย่อย (เช่น brand.name) หรือถ้าไม่มีก็ดึงจาก ID ตรงๆ
                                        const brandName = item.brand?.name || "-";
                                        const modelName = item.model?.name || "-";
                                        const serieName = item.serie?.name || "-";
                                        const catName = item.part_category?.name || "-";
                                        const uomName = item.uom?.name || "EA";

                                        return (
                                            <tr key={idx} className="border-bottom border-light bg-white">
                                                <td className="text-nowrap">
                                                    <span className={`fw-bold text-14 pointer hover-underline ${isActive ? "text-primary" : "text-secondary"}`}>{item.part_number}</span>
                                                </td>

                                                <td className="text-nowrap">
                                                    <div className={`text-14 ${isActive ? "text-dark" : "text-secondary"}`}>{item.name || item.description}</div>
                                                </td>

                                                <td className="text-nowrap">
                                                    <div className={`text-14 fw-bold ${isActive ? "text-dark" : "text-secondary"}`}>{brandName}</div>
                                                </td>

                                                <td className="text-nowrap">
                                                    <div className={`text-14 ${isActive ? "text-dark" : "text-secondary"}`}>{modelName}</div>
                                                </td>
                                                <td className="text-nowrap">
                                                    <div className={`text-14 ${isActive ? "text-dark" : "text-secondary"}`}>{serieName}</div>
                                                </td>

                                                <td className="text-center">
                                                    <span className={`badge bg-primary-light text-primary rounded-2 px-2 py-1 fw-bold text-10 border`}>{catName}</span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="text-dark text-14">{uomName}</span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="text-dark text-14">{item.reorder_point || 0}</span>
                                                </td>

                                                <td className="text-center">
                                                    <span className="text-dark text-14">{item.reorder_qty || item.min_stock || 0}</span>
                                                </td>

                                                <td className="text-center">
                                                    <div className="text-dark text-14">{item.lead_time_days || 0} {t("days")}</div>
                                                </td>

                                                <td className="text-end">
                                                    <div className="fw-bold text-dark text-14">{this.formatNumber(item.uom_cost || 0)}</div>
                                                </td>

                                                <td className="text-center">
                                                    <span className={`badge bg-${statusColor}-light text-${statusColor} rounded-pill px-3 py-1 fw-bold text-10 border border-${statusColor}`}>
                                                        {statusText}
                                                    </span>
                                                </td>

                                                <td className="text-center">
                                                    <div className="d-flex align-items-center gap-2 justify-content-center">
                                                        <ActionIconButton
                                                            label={t("view")}
                                                            icon={ACTION_ICONS.view}
                                                            variant="primary"
                                                            onClick={() => this.View(item)}
                                                        />
                                                        {can("part-master.update") && (
                                                        <ActionIconButton
                                                            label={t("edit")}
                                                            icon={ACTION_ICONS.edit}
                                                            variant="warning"
                                                            onClick={() => this.Edit(item)}
                                                        />
                                                        )}
                                                        {can("part-master.delete") && (
                                                        <ActionIconButton
                                                            label={t("delete")}
                                                            icon={ACTION_ICONS.delete}
                                                            variant="danger"
                                                            onClick={() => this.Delete(item.uid)}
                                                        />
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="12" className="text-center py-4 text-secondary">
                                            {t("no_data_found")}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} 1-{data?.length} {t("of")} {this.formatNumber(count)} {t("total_parts_suffix")}
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                    </div>
                </div>
            </div>

            {/* MODAL: Add / Edit Part */}
            <Modal size="lg" show={modal_create} onHide={() => this.setState({ modal_create: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{this.state.uid ? t("edit_part_title") : t("add_new_part_title")}</h4>
                </Modal.Header>
                <Modal.Body className="px-4 py-2 bg-white">
                    <div className="row g-2">
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("part_code")} {required}
                            </label>
                            <input
                                type="text"
                                className="form-control py-2 rounded-3 text-secondary"
                                placeholder="PRT-XXXXXX"
                                value={form_part_code}
                                onChange={(e) => this.setState({ form_part_code: e.target.value })}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("barcode")}</label>
                            <input
                                type="text"
                                className="form-control py-2 rounded-3 text-secondary"
                                placeholder={t("barcode")}
                                value={form_barcode}
                                onChange={(e) => this.setState({ form_barcode: e.target.value })}
                            />
                        </div>

                        <div className="col-12">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("description")} {required}
                            </label>
                            <input
                                type="text"
                                className="form-control py-2 rounded-3 text-secondary"
                                placeholder={t("description")}
                                value={form_desc}
                                onChange={(e) => this.setState({ form_desc: e.target.value })}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold mb-2">{t("brand")} </label>
                            {/* ถ้า API เป็น dropdown ก็ปรับเป็น select ได้ */}
                            {/* <Select
                                className="form-control w-100"
                                options={data_brands.map(e=>({value: e.uid, label: e.name}))}
                                value={form_brand}
                                onChange={(e) => this.setState({ form_brand: e })}
                                /> */}
                            <select className="form-select w-100" value={form_brand} onChange={(e) => this.setState({ form_brand: e.target.value })}>
                                <option value="">{t("select_brand_option")}</option>
                                {/* {data_brands?.map((group, idx) => (
                                    <optgroup key={idx} label={group.name}>
                                    {group.children?.map((brand, i) => (
                                        <option key={i} value={brand.uid}>
                                        {brand.name}
                                        </option>
                                    ))}
                                    </optgroup>
                                ))} */}
                                {sortOptions(activeTreeOptions(data_brands, form_brand, { keys: ["uid"] }), { by: "name", childKey: "children" }).map((group, idx) => (
                                    <>
                                        <option key={idx} value={group.uid}>
                                            {group.name}
                                        </option>
                                        {group.children?.map((brand, i) => (
                                            <option key={i} value={brand.uid}>
                                                {brand.name}
                                            </option>
                                        ))}
                                    </>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold mb-2">{t("label_series_1")}</label>
                            <Select className="form-control w-100" placeholder={t("label_series_1")} options={activeOptions(data_models, form_model)} value={form_model} onChange={(e) => this.setState({ form_model: e })} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("label_model_2")}</label>
                            <Select className="form-control w-100" placeholder={t("label_model_2")} options={activeOptions(data_series, form_serie)} value={form_serie} onChange={(e) => this.setState({ form_serie: e })} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold mb-2">{t("category_1")} {required}</label>
                            <Select className="form-control w-100" placeholder={t("category_1")} options={activeOptions(data_categories, form_category1)} value={form_category1} onChange={(e) => this.setState({ form_category1: e })} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold mb-2">{t("category_2")}</label>
                            <Select className="form-control w-100" placeholder={t("category_2")} options={activeOptions(data_categories, form_category2)} value={form_category2} onChange={(e) => this.setState({ form_category2: e })} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 fw-bold mb-2">{t("category_3")}</label>
                            <Select className="form-control w-100" placeholder={t("category_3")} options={activeOptions(data_categories, form_category3)} value={form_category3} onChange={(e) => this.setState({ form_category3: e })} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("unit")} {required}
                            </label>
                            {/* สามารถปรับเป็น Select Dropdown UOM ID ได้ */}
                            <Select className="form-control w-100" placeholder={t("unit")} options={activeOptions(data_uoms, form_unit)} value={form_unit} onChange={(e) => this.setState({ form_unit: e })} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("unit_cost")}</label>
                            <input
                                type="number"
                                className="form-control py-2 rounded-3 text-secondary"
                                placeholder="0.00"
                                value={form_unit_cost}
                                onChange={(e) => this.setState({ form_unit_cost: e.target.value })}
                                onFocus={() => {
                                    if (form_unit_cost == 0) {
                                        this.setState({ form_unit_cost: "" });
                                    }
                                }}
                                onBlur={() => {
                                    if (form_unit_cost === "") {
                                        this.setState({ form_unit_cost: 0 });
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("selling_price_label")}</label>
                            <input
                                type="number"
                                className="form-control py-2 rounded-3 text-secondary"
                                placeholder="0.00"
                                value={form_unit_price}
                                onChange={(e) => this.setState({ form_unit_price: e.target.value })}
                                onFocus={() => {
                                    if (form_unit_price == 0) {
                                        this.setState({ form_unit_price: "" });
                                    }
                                }}
                                onBlur={() => {
                                    if (form_unit_price === "") {
                                        this.setState({ form_unit_price: 0 });
                                    }
                                }}
                            />
                        </div>

                        <hr />
                        <div className="col-12">
                            <h6 className="fw-bold text-dark">{t("inventory_settings")}</h6>
                        </div>

                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("min_stock_label")}</label>
                            <input
                                type="number"
                                className="form-control py-2 rounded-3 text-dark"
                                value={form_min_stock}
                                onChange={(e) => this.setState({ form_min_stock: e.target.value })}
                                onFocus={() => {
                                    if (form_min_stock == 0) {
                                        this.setState({ form_min_stock: "" });
                                    }
                                }}
                                onBlur={() => {
                                    if (form_min_stock === "") {
                                        this.setState({ form_min_stock: 0 });
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("reorder_point")}</label>
                            <input
                                type="number"
                                className="form-control py-2 rounded-3 text-dark"
                                value={form_reorder_pt}
                                onChange={(e) => this.setState({ form_reorder_pt: e.target.value })}
                                onFocus={() => {
                                    if (form_reorder_pt == 0) {
                                        this.setState({ form_reorder_pt: "" });
                                    }
                                }}
                                onBlur={() => {
                                    if (form_reorder_pt === "") {
                                        this.setState({ form_reorder_pt: 0 });
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("reorder_qty_label")}</label>
                            <input
                                type="number"
                                className="form-control py-2 rounded-3 text-dark"
                                value={form_reorder_qty}
                                onChange={(e) => this.setState({ form_reorder_qty: e.target.value })}
                                onFocus={() => {
                                    if (form_reorder_qty == 0) {
                                        this.setState({ form_reorder_qty: "" });
                                    }
                                }}
                                onBlur={() => {
                                    if (form_reorder_qty === "") {
                                        this.setState({ form_reorder_qty: 0 });
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark fw-bold mb-2">
                                {t("lead_time")} ({t("days")})
                            </label>
                            <input
                                type="number"
                                className="form-control py-2 rounded-3 text-dark"
                                value={form_lead_time}
                                onChange={(e) => this.setState({ form_lead_time: e.target.value })}
                                onFocus={() => {
                                    if (form_lead_time == 0) {
                                        this.setState({ form_lead_time: "" });
                                    }
                                }}
                                onBlur={() => {
                                    if (form_lead_time === "") {
                                        this.setState({ form_lead_time: 0 });
                                    }
                                }}
                            />
                        </div>
                        <div className="col-md-12">
                            <label className="form-label text-14 text-dark fw-bold mb-2">{t("primary_supplier_section")}</label>
                            <Select className="form-control w-100" placeholder={t("select_supplier")} options={activeOptions(data_suppliers, form_supplier)} value={form_supplier} onChange={(e) => this.setState({ form_supplier: e })} />
                        </div>

                        <hr />
                        <div className="col-12">
                            <h6 className="fw-bold text-dark">{t("compatibility_reference")}</h6>
                        </div>

                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold mb-2">{t("reference_old_part_field")}</label>
                            <Select className="form-control w-100" placeholder={t("select_legacy_part_placeholder")} options={activeOptions(data_parts, form_legacy_part_id)} value={form_legacy_part_id} onChange={(e) => this.setState({ form_legacy_part_id: e })} />
                            <small className="text-secondary">{t("legacy_part_hint")}</small>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold mb-2">{t("compatible_series_field")}</label>
                            <Select
                                className="form-control w-100"
                                placeholder={t("select_compatible_series_placeholder")}
                                options={activeOptions(data_models, form_compatible_series)}
                                value={select_compatible_series}
                                onChange={(e) => {
                                    this.setState((prevState) => {
                                        // เช็คว่ามีข้อมูลนี้อยู่ใน Array หรือยัง (เช็คจาก e.value)
                                        const isExist = prevState.form_compatible_series.some((item) => item === e);

                                        return {
                                            select_compatible_series: null,
                                            // ถ้ามีอยู่แล้ว ให้ใช้ Array เดิม, ถ้ายังไม่มี ให้ต่อเพิ่มเข้าไป
                                            form_compatible_series: isExist ? prevState.form_compatible_series : [...prevState.form_compatible_series, e],
                                        };
                                    });
                                }}
                            />
                            <small className="text-secondary">{t("multi_select_hint")}</small>
                            <div className="d-flex flex-wrap">
                                {form_compatible_series?.map((e, i) => (
                                    <span className="d-flex bg-primary-light px-3 py-1 rounded-3 me-2 mb-2">
                                        {data_models.find((s) => s.value === e)?.label || ""}
                                        <span
                                            className="icon text-danger ms-2 pointer"
                                            onClick={async () => {
                                                if (
                                                    await alert(
                                                        "",
                                                        "warning",
                                                        t("delete_item"),
                                                        t("delete_desc"),
                                                        t("confirm"),
                                                        t("cancel")
                                                    )
                                                ) {
                                                    this.setState((prevState) => {
                                                        const updatedArray = prevState.form_compatible_series.filter((item) => item !== e);
                                                        return { form_compatible_series: updatedArray };
                                                    });
                                                }
                                            }}
                                        >
                                            {"\uf00d"}
                                        </span>
                                    </span>
                                ))}
                            </div>
                        </div>
                        <div className="col-md-12 mt-3">
                            <div className="bg-primary-light px-3 pt-3 pb-2 rounded-4 text-primary" style={{ borderLeft: "4px solid #3b82f6" }}>
                                <b>{t("business_logic_rationale_title")}</b>
                                <br />
                                <ul>
                                    <li>
                                        <b>{t("reference_old_part_field")}</b> - {t("reference_old_part_rationale")}
                                    </li>
                                    <li>
                                        <b>{t("compatible_series_field")}</b> - {t("compatible_series_rationale")}
                                    </li>
                                    <li>
                                        <b>{t("renamed_labels_title")}</b> {t("renamed_labels_rationale")}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top border-light pt-3 px-4 pb-4 d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false })}>
                        {t("cancel")}
                    </button>
                    {(this.state.uid ? can("part-master.update") : can("part-master.create")) && (
                    <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold shadow-sm" style={{ backgroundColor: "#3b82f6", borderColor: "#3b82f6" }} onClick={this.CreateUpdate}>
                        {t("save")}
                    </button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* MODAL: View Details */}
            <Modal size="lg" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{t("part_details_title")}</h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-light">
                    {selected_part && (
                        <div className="row g-4">
                            <div className="col-12">
                                <div className="bg-white p-4 rounded-4 shadow-sm">
                                    <h6 className="fw-bold text-primary mb-3 border-bottom pb-2">{t("basic_info")}</h6>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <div className="text-secondary text-12">{t("part_code_view")}</div>
                                            <div className="fw-bold text-dark">{selected_part.part_number || "-"}</div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="text-secondary text-12">{t("barcode_view")}</div>
                                            <div className="fw-bold text-dark">{selected_part.barcode || "-"}</div>
                                        </div>
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("description_view")}</div>
                                            <div className="fw-bold text-dark text-16">{selected_part.name || selected_part.description || "-"}</div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="text-secondary text-12">{t("brand")}</div>
                                            <div className="fw-bold text-dark">{selected_part.brand?.name || selected_part.brand_id || "-"}</div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="text-secondary text-12">{t("model")}</div>
                                            <div className="fw-bold text-dark">{selected_part.model?.name || selected_part.model_id || "-"}</div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="text-secondary text-12">{t("category")}</div>
                                            <div className="fw-bold text-dark">{selected_part.category?.name || selected_part.part_category_id || "-"}</div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="text-secondary text-12">{t("uom")}</div>
                                            <div className="fw-bold text-dark">{selected_part.uom?.name || selected_part.uom_id || "-"}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                                    <h6 className="fw-bold text-primary mb-3 border-bottom pb-2">{t("pricing_cost_section_title")}</h6>
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("unit_cost")}</div>
                                            <div className="fw-bold text-dark text-16">{this.formatNumber(selected_part.uom_cost)}</div>
                                        </div>
                                        <div className="col-12">
                                            <div className="text-secondary text-12">{t("selling_price_label")}</div>
                                            <div className="fw-bold text-dark text-16">{this.formatNumber(selected_part.selling_price)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="bg-white p-4 rounded-4 shadow-sm h-100">
                                    <h6 className="fw-bold text-primary mb-3 border-bottom pb-2">{t("inventory_settings")}</h6>
                                    <div className="row g-3">
                                        <div className="col-6">
                                            <div className="text-secondary text-12">{t("min_stock_view")}</div>
                                            <div className="fw-bold text-dark">{selected_part.min_stock || 0}</div>
                                        </div>
                                        <div className="col-6">
                                            <div className="text-secondary text-12">{t("reorder_point")}</div>
                                            <div className="fw-bold text-dark">{selected_part.reorder_point || 0}</div>
                                        </div>
                                        <div className="col-6">
                                            <div className="text-secondary text-12">{t("reorder_qty_view")}</div>
                                            <div className="fw-bold text-dark">{selected_part.reorder_qty || 0}</div>
                                        </div>
                                        <div className="col-6">
                                            <div className="text-secondary text-12">{t("lead_time")}</div>
                                            <div className="fw-bold text-dark">{selected_part.lead_time_days || 0} {t("days")}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-white border-top border-light pt-3 px-4 pb-4 d-flex justify-content-end">
                    <button className="btn btn-secondary px-4 py-2 text-white rounded-3 fw-bold shadow-sm" onClick={() => this.setState({ modal_view: false })}>
                        {t("close")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}